import { enqueueSnackbar } from 'notistack'

export const sendErrorNotification = (message: string) => {
  enqueueSnackbar(message, { variant: 'error' })
}

export const sendSuccessNotification = (message: string) => {
  enqueueSnackbar(message, { variant: 'success' })
}

export const sendInfoNotification = (message: string) => {
  enqueueSnackbar(message, { variant: 'info' })
}
